export default abstract class AcadBaseDocument {
  static readonly PATH: string = "";
}
